//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export interface OrientationFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  section: FilterSection<string> | undefined;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
}

export const DEFAULT_ORIENTATION_FILTER_SECTION: FilterSection<string> = {
  options: [
    {
      isSelected: false,
      label: 'Vertical',
      value: 'Vertical',
      trackingId: MediaLibraryTrackingIds.ORIENTATION_VERTICAL_CHECKBOX,
    },
    {
      isSelected: false,
      label: 'Horizontal',
      value: 'Horizontal',
      trackingId: MediaLibraryTrackingIds.ORIENTATION_HORIZONTAL_CHECKBOX,
    },
    {
      isSelected: false,
      label: 'Square',
      value: 'Square',
      trackingId: MediaLibraryTrackingIds.ORIENTATION_SQUARE_CHECKBOX,
    },
  ],
  paramKey: 'orientation',
};

export const OrientationFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_ORIENTATION_FILTER_SECTION,
}: OrientationFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter
        isDisabled={isDisabled}
        onChange={onChange}
        section={section}
      />
    </CollapsibleSection>
    <HR />
  </>
);
